import { SquaresTableConfig } from '../../../types/dynamicComponents';

export const SQUARES_TABLE_COMPONENT_TYPE = 'squares_table';

export const DEFAULT_SQUARES_TABLE_CONFIG: SquaresTableConfig = {
  minNumber: 1,
  maxNumber: 40,
  defaultNumber: 5,
};

export const getDefaultSquaresConfigJson = (): string => JSON.stringify(DEFAULT_SQUARES_TABLE_CONFIG, null, 2);

export const parseSquaresTableConfig = (configJson?: string | null): SquaresTableConfig => {
  if (!configJson) {
    return DEFAULT_SQUARES_TABLE_CONFIG;
  }

  try {
    const parsed = JSON.parse(configJson) as Partial<SquaresTableConfig>;

    const minNumber = Number.isFinite(parsed.minNumber)
      ? Math.max(1, Math.floor(parsed.minNumber!))
      : DEFAULT_SQUARES_TABLE_CONFIG.minNumber;

    const maxNumber = Number.isFinite(parsed.maxNumber)
      ? Math.max(minNumber, Math.floor(parsed.maxNumber!))
      : DEFAULT_SQUARES_TABLE_CONFIG.maxNumber;

    const defaultNumber = Number.isFinite(parsed.defaultNumber)
      ? Math.min(maxNumber, Math.max(minNumber, Math.floor(parsed.defaultNumber!)))
      : DEFAULT_SQUARES_TABLE_CONFIG.defaultNumber;

    return {
      minNumber,
      maxNumber,
      defaultNumber,
    };
  } catch {
    return DEFAULT_SQUARES_TABLE_CONFIG;
  }
};
